import angular from "angular";

angular
    .module('XMLHttpRequest', [])
    .factory('XMLHttpRequest', function () {
        return {
            request: function (config) {
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                return config;
            }
        }
    });

export default 'XMLHttpRequest';


// WEBPACK FOOTER //
// ./resources/assets/modules/app/XMLHttpRequest.js